// Onboarding SCA des structures (KYC/SCA Mangopay). Le tenant n'a pas de scope
// « admin » transverse : chaque scope est par domaine, et celui-ci suit la famille
// deja declaree sur l'API payment (payment:manage:payout, payment:manage:settings).
// Accorde au role back-office bo_administrator.
export const SCA_MANAGE_SCOPES = ['payment:manage:sca']
